import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PACIFIC_PROMO_FREE_SAMPLE = defineFcm('pacific_promo_free_sample')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				impressions: { type: 'number' },
				amount: { type: 'number' },
				startDate: { type: 'string' },
				minSignatureCount: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: ['comms-stack', 'corgi-front-end', 'corgi-middle-end'],
		context: 'pacific_promo_free_sample',
		description:
			'FCM to show a dynamic value for the number of impressions that the user can get via free promotion credits.',
		import: false,
		template: {
			impressions: 625,
			amount: 25,
			startDate: '2023-03-16T00:00:00.000Z',
			minSignatureCount: 5,
		},
	});
